// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const anyValid = (value: string) => true;

export const notBlank = (value: string) => value.trim() !== '';

export default {};
